import { HttpInterceptorFn } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { ToastService } from '@staffler/shared';
import { TranslateService } from '@ngx-translate/core';
import { AuthStore } from '../storage/auth';
import { isSessionExpiredResponse } from '../session';
import * as Sentry from '@sentry/capacitor';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const toastService = inject(ToastService);
  const authStore = inject(AuthStore);
  const injector = inject(Injector);
  const hadSession = authStore.isAuthenticated();

  return next(req).pipe(
    catchError(error => {
      if (hadSession && isSessionExpiredResponse(error, req.url)) {
        return throwError(() => error);
      }

      if (error?.status >= 500) {
        Sentry.captureException(error, {
          tags: { origin: 'backend', http_status: String(error.status) },
          extra: {
            url: req.url,
            method: req.method,
            apiErrorCodes: error?.error?.apiErrors?.map((e: { code: string }) => e.code),
          },
        });
      }

      const translate = injector.get(TranslateService); // lazy inject
      const apiErrors = error?.error?.apiErrors;

      const message: string = apiErrors?.length
        ? apiErrors.map((e: { code: string }) => translate.instant(`errors.${e.code}`)).join('\n')
        : translate.instant('errors.UNKNOWN');

      toastService.showError(message);
      return throwError(() => error);
    })
  );
};
